export default {
    data() {
        return {
            subscriptions: [],
        }
    },

    beforeUnmount() {
        this.unsubscribe()
    },

    methods: {
        replaceSubscription(name, source, handler) {
            return this.unsubscribe(name).subscribe(source, handler, name)
        },

        subscribe(source, handler, name = null) {
            const subscription = typeof handler !== 'function' ? source : source.subscribe(handler)

            this.subscriptions.push({ name, subscription })

            return subscription
        },

        subscribed(name) {
            return this.subscriptions.find((subscription) => subscription.name === name) !== undefined
        },

        unsubscribe(name = null) {
            if (typeof name === 'string') {
                name = [name]
            }

            this.subscriptions.forEach((subscription) => {
                if (name === null || name.indexOf(subscription.name) > -1) {
                    subscription.subscription.unsubscribe()
                }
            })

            return this
        },
    },
}
